import fs from 'fs';
import path from 'path';

import chalk from 'chalk';
import * as wikirefs from 'wikirefs';

import { MD } from '../util/const';
import { getFileUris } from '../util/util';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function rehead(targetFname: string, oldFragment: string, newFragment: string, _opts?: any): void {
  const output: string[] = [chalk.green('UPDATED FILES:')];
  const outputError: string[] = [chalk.red('UPDATE FAILED: ')];
  const vaultFilePaths: string[] = getFileUris();
  for (const thisFilePath of vaultFilePaths) {
    const oldContent: string = fs.readFileSync(thisFilePath, 'utf8');
    const newContent: string = wikirefs.renameHeader(oldFragment, newFragment, oldContent, { filename: targetFname });
    try {
      fs.writeFileSync(thisFilePath, newContent, 'utf8');
      if (oldContent !== newContent) {
        output.push('  ' + path.basename(thisFilePath, MD));
      }
    } catch (e: any) {
      outputError.push(chalk.red('  ' + e));
    }
  }
  if (output.length === 1) {
    output.push(chalk.dim('  none'));
  }
  const lines: string[] = (outputError.length > 1)
    ? output.concat(outputError)
    : output;
  console.log(lines.join('\n'));
}
